import { Link } from "react-router-dom";
import { ArrowRight, Warning, CheckCircle } from "@phosphor-icons/react";
import { Reveal } from "./Reveal";

const RENEW_WINDOW_DAYS = 60;

export const daysUntil = (ddmmyyyy) => {
  if (!ddmmyyyy) return null;
  const [d, m, y] = ddmmyyyy.split("/").map(Number);
  if (!d || !m || !y) return null;
  const expiry = new Date(y, m - 1, d);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return Math.ceil((expiry - today) / 86400000);
};

export const RenewalNotice = ({ card, c }) => {
  const days = daysUntil(card?.expires);
  if (days === null || days > RENEW_WINDOW_DAYS) return null;
  const expired = days < 0;
  const title = expired ? c.renewExpiredTitle : c.renewSoonTitle;
  const body = expired
    ? c.renewExpiredBody.replace("{date}", card.expires)
    : c.renewSoonBody.replace("{days}", String(days)).replace("{date}", card.expires);
  return (
    <Reveal delay={0.06} data-testid="renewal-notice">
      <div className={`flex flex-col gap-5 rounded-2xl border p-6 md:flex-row md:items-center md:justify-between ${expired ? "border-terracotta/40 bg-terracotta/5" : "border-ochre/50 bg-ochre/10"}`}>
        <div className="flex items-start gap-4">
          <Warning size={28} weight="duotone" className={`mt-0.5 shrink-0 ${expired ? "text-terracotta" : "text-ochre"}`} />
          <div>
            <h3 className="font-display font-bold tracking-tight text-lg text-ink" data-testid="renewal-title">{title}</h3>
            <p className="mt-1 text-sm text-stone leading-relaxed" data-testid="renewal-body">{body}</p>
          </div>
        </div>
        <Link to="/sostienici?scopo=rinnovo" data-testid="renewal-link" className="group inline-flex shrink-0 items-center gap-2 rounded-full bg-ink px-6 py-3 font-semibold text-bone transition-colors duration-200 hover:bg-terracotta">
          {c.renewBtn} <ArrowRight size={18} className="transition-transform duration-200 group-hover:translate-x-1" />
        </Link>
      </div>
    </Reveal>
  );
};

export const CardStatus = ({ expires, c }) => {
  const days = daysUntil(expires);
  if (days === null) return null;
  if (days < 0) return <span className="inline-flex items-center gap-1 rounded-full bg-terracotta px-2.5 py-0.5 text-[11px] font-semibold text-white" data-testid="card-status">{c.statusExpired}</span>;
  if (days <= RENEW_WINDOW_DAYS) return <span className="inline-flex items-center gap-1 rounded-full bg-ochre px-2.5 py-0.5 text-[11px] font-semibold text-ink" data-testid="card-status">{c.statusExpiring.replace("{days}", String(days))}</span>;
  return <span className="inline-flex items-center gap-1 rounded-full bg-forest px-2.5 py-0.5 text-[11px] font-semibold text-bone" data-testid="card-status"><CheckCircle size={12} weight="bold" /> {c.statusValid}</span>;
};
